module.exports = __webpack_public_path__ + "img/bullet-list-text.cff72b56.svg";